import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootBody: {
				padding: "0px 16px"
			},
			rootProduct: {
				display: "flex",
				alignItems: "center"
			},
			rootImage: {
				"& >img": {
					objectFit: "contain",
					margin: "10px 0px"
				}
			},
			rootInfo: {
				width: "100%",
				padding: "10px 0px 10px 5px"
			},
			name: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 14,
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				width: 235
			},
			quantity: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 14
			},
			subText: {
				color: theme.palette.grey[50],
				fontSize: 14
			},
			body: {
				display: "flex",
				marginTop: 10,
				marginRight: 16,
				alignItems: "center",
				justifyContent: "space-between"
			},
			btnWatchProduct: {
				width: "100%",
				textAlign: "center",
				"& > button": {
					fontWeight: 400,
					color: theme.palette.secondary.main,
					textTransform: "none",
					padding: 0
				}
			},
			totalPrice: {
				marginTop: 10,
				background: theme.palette.grey[600],
				borderRadius: 4
			},
			textPrice: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 16,
				textAlign: "end"
			},
			btnProductDetail: {
				width: "100%",
				marginTop: 20,
				paddingBottom: 10,
				textAlign: "center",
				"& > button": {
					fontWeight: 400,
					color: theme.palette.secondary.main,
					textTransform: "none",
					padding: "3px 20px",
					border: `1px solid ${theme.palette.secondary.main}`
				}
			}
		}),
	{
		name: "BodyHistoryOrder",
		index: 1
	}
);

export default useStyles;
